import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (res.ok || res.status === 429) {
        setSent(true);
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.detail || t('auth.couldNotProcess'));
      }
    } catch {
      setError(t('auth.networkError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 max-w-md py-16">
        <button onClick={() => navigate('/login')} className="mb-8 text-sm text-gray-500 hover:text-[#134168] transition-colors">{t('auth.backToLogin')}</button>

        <div className="bg-white rounded-3xl p-8 shadow-sm">
          {sent ? (
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 text-3xl">📧</div>
              <h1 className="text-2xl font-bold text-[#134168] mb-3">{t('auth.checkInbox')}</h1>
              <p className="text-gray-600 text-sm mb-6">{t('auth.forgotInstructions')}</p>
              <button onClick={() => navigate('/login')} className="w-full bg-[#134168] text-white py-3 rounded-full font-bold hover:bg-[#39b4aa] transition-colors">
                {t('auth.backToLogin').replace('← ', '')}
              </button>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold text-[#134168] mb-2">{t('auth.forgotPassword')}</h1>
              <p className="text-gray-500 text-sm mb-6">{t('auth.forgotIntro')}</p>

              {error && <div className="mb-4 text-red-600 text-sm bg-red-50 border border-red-200 rounded-xl p-3">{error}</div>}

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">{t('auth.email')}</label>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder={t('auth.emailPlaceholder2')}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#134168]"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#134168] text-white py-3 rounded-full font-bold hover:bg-[#39b4aa] transition-colors disabled:opacity-50"
                >
                  {loading ? t('auth.sending') : t('auth.sendRecoveryLink')}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
